<template lang="html">
  <div class="card" @click="productClick">
    <div class="img-wrap">
      <img style="width:260px" :src="cardVal.img+'?imageMogr2/gravity/Center/thumbnail/!520x520r/crop/520x520'" alt="斑马旅旅游">
      <div class="card-style card-style-bg1" v-if="cardVal.mark[0] === '私家游'">{{cardVal.mark[0]}}</div>
      <div class="card-style card-style-bg2" v-else-if="cardVal.mark[0] === '精品团'">{{cardVal.mark[0]}}</div>
      <div class="card-style card-style-bg5" v-else>{{cardVal.mark[0]}}</div>
    </div>
    <div class="title" style="font-weight:bold;font-size:15px">
      {{cardVal.title}}
    </div>
    <div class="sub-title">
      {{cardVal.subtitle}}
    </div>
    <div class="price-comment">
      <div class="price">
        <span class="price-val">￥{{cardVal.price}}</span>
        <span class="price-tip">起</span>
      </div>
      <div class="comment" v-show="cardVal.comment_count !== 0 ? true: false">
        <i class="whaletrip-icon icon-topic"></i>
        <span>{{cardVal.comment_count}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pc-card',
    props: {
      cardVal: Object
    },
    data () {
      return {
      }
    },
    methods: {
      productClick () {
        window.location.href = `/product/productDetail?productId=${this.cardVal.id}`
        // this.$router.push({
        //   path: '/product/productDetail',
        //   query: {productId: this.cardVal.id}
        // })
        // window.location.reload()
      }
    },
    created () {
    }
  }
</script>

<style lang="less">
  @import '../../styles/theme.less';
  .card {
    width: 260px;
    min-height: 396px;
    // border:1px solid green;
    padding-bottom: 10px;
    margin-right: 15px;
    margin-bottom:40px;
    display: inline-block;
    .img-wrap{
      position: relative;
      transition: 0.5s;
      height: 260px;
      margin-bottom: 10px;
      border-radius: 3px;
      box-sizing: border-box;
      overflow: hidden;
      img {
        border-radius: 3px;
        transition: 1s;
      }
      img:hover{
        opacity: 0.75;
      }
      .card-style {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 65px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        color: #fff;
        font-size: 12px;
        border-radius: 0px 3px 0px 0px;
      }
      .card-style-bg1{
        background: #60C6A5;
      }
      .card-style-bg2{
        background: #FFAB40;
      }
      .card-style-bg5{
        background: #FF8A80;
      }
    }
    .title {
      color: @grey-ll1-color;
      font-size: @grey-ll1-size;
      line-height: 24px;
      height: 48px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      padding: 0 10px;
      margin-bottom: 10px;
    }
    .sub-title {
      height: 32px;
      line-height: 16px;
      font-size: 12px;
      color: #6E747D;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      padding: 0 10px;
    }
    .price-comment {
      margin-top: 15px;
      padding: 0 10px;
      .price {
        display: inline-block;
        .price-val {
          color: @primary-color;
          font-size: @primary-ll-size;
        }
        .price-tip {
          color: @grey-sc3-color;
          font-size: @grey-sc3-size;
        }
      }
      .comment{
        display: inline-block;
        float: right;
        .whaletrip-icon {
          font-size: 14px;
          color: @grey-sc3-color;
        }
        span{
          color: @grey-sl3-color;
          font-size: @grey-sl3-size;
        }
      }
    }
    &:nth-of-type(4n) {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/card/index.vue